import { metrics } from '@seek/metrics-js';
import { TextLink } from 'braid-design-system';

import { CREATE_RESUME_PAGE } from 'src/components/Router';
import { Link } from 'src/components/Router/Link';
import { usePage } from 'src/components/Router/usePage';
import { analyticsClient } from 'src/modules/analytics';

export const ProfileVisibilityNudgeLink = ({ text }: { text: string }) => {
  const page = usePage();
  const isCreateResumePage = page === CREATE_RESUME_PAGE;

  return (
    <Link
      data={{ testid: 'profile-visibility-nudge-link' }}
      card="profile-visibility"
      mode="EDIT"
      {...(isCreateResumePage ? { page: 'profile-page' } : {})}
      component={TextLink}
      onClick={() => {
        metrics.count('nudge_action', ['id:profile-visibility']);
        analyticsClient.cardOpened({
          origin: 'manage resumes',
          currentPageSection: 'visibility settings',
          currentPageSectionState: 'edit',
        });
      }}
      params={{ focusOn: 'level' }}
      hitArea="large"
      weight="weak"
    >
      {text}
    </Link>
  );
};
